import Vue from 'vue';

import 'normalize.css/normalize.css'; // A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/styles/index.scss'; // global css

import md5 from 'js-md5';
import App from './App.vue';
import store from './store';
import router from './router';
import '@/icons';

// import '@/icons'; // icon
import '@/permission';

import elSelectLoadmore from './directives';

Vue.prototype.$md5 = md5; // permission control

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
// require('./mock');


Vue.use(ElementUI);

Vue.config.productionTip = false;

Vue.use(elSelectLoadmore);

// eslint-disable-next-line
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});
